<template>
    <div class="freetargetImage-box">
        <!-- <div class="marqueeWrapper rewardBlast-rule">
            <div class="raceGame-noteStrip">
              Notice : 🎉 Special Event Alert! 🎉 Starts on 20 Oct 2025 — Play More, Earn More! 🎁
            </div>
        </div> -->
        <img :src='DiwaliRewardBlast' alt="" />
    </div>    
</template>
<script>
import './TargetRules.css'
import DiwaliRewardBlast from '../../assets/images/diwaliRewardBlast.png'
export default {
    name: 'RewardBlastRule',
    data() {
        return {
            DiwaliRewardBlast: DiwaliRewardBlast,
        }
    },
}
</script>
